import React, { useState } from "react";
import { Link } from "react-router-dom";
import AgeIcon from "../../assets/age-group.png";
import ClockIcon from "../../assets/clock.png";
import BookIcon from "../../assets/book.png";
import ActivitiesIcon from "../../assets/activities.png";

const CourseCard = ({ course }) => {
  const [expanded, setExpanded] = useState(false);
  return (
    <div className="z-10 flex h-full flex-col overflow-hidden rounded-[14px] bg-white shadow-[0px_0px_9.8px_1px_rgba(0,0,0,0.25)] sm:rounded-[18px]">
      <img
        src={course.img}
        alt={course.name}
        className="h-44 w-full object-cover sm:h-52 lg:h-56 2xl:h-64"
      />

      <div className="flex flex-1 flex-col px-3 pb-1 text-black sm:px-4 2xl:pl-6">
        <h2 className="mt-4 min-h-0 text-lg font-bold capitalize leading-snug sm:mt-6 sm:min-h-[46px] sm:text-xl sm:leading-[23px] 2xl:mt-[30px]">
          {course.name}
        </h2>

        <div className="mt-2 min-h-0 sm:min-h-[101px] 2xl:mt-4">
          <p
            className={`max-w-full text-sm font-normal leading-[18px] sm:text-base sm:leading-[19px] ${
              expanded ? "" : "line-clamp-3 sm:line-clamp-4"
            }`}
          >
            {course.desc || "No description available."}
          </p>
          {course.desc && course.desc.length > 120 ? (
            <button
              type="button"
              onClick={() => setExpanded(!expanded)}
              className="mt-1 text-sm text-blue-500 hover:underline"
            >
              {expanded ? "Show less" : "Read more"}
            </button>
          ) : null}
        </div>

        <p className="mt-3 text-sm font-medium leading-[19px] sm:text-base">
          Details:
        </p>

        <div className="mt-2 grid grid-cols-1 gap-2 min-[380px]:grid-cols-2 sm:mt-3 sm:gap-x-2 sm:gap-y-2.5">
          <div className="flex items-start gap-2 text-sm font-normal leading-[18px] sm:items-center sm:gap-3 sm:leading-[19px]">
            <img src={AgeIcon} alt="" className="mt-0.5 h-4 w-4 shrink-0 sm:mt-0" />
            <p className="min-w-0 break-words">
              <span className="font-medium">Age Group:</span> {course.age}
            </p>
          </div>
          <div className="flex items-start gap-2 text-sm font-normal leading-[18px] sm:items-center sm:gap-3 sm:leading-[19px]">
            <img
              src={ClockIcon}
              alt=""
              className="mt-0.5 h-4 w-4 shrink-0 sm:mt-0"
            />
            <p className="min-w-0 break-words">
              <span className="font-medium">Duration:</span> {course.duration}
            </p>
          </div>
          {/* <div className="flex items-start gap-2 text-sm font-normal leading-[18px] sm:items-center sm:gap-3 sm:leading-[19px]">
            <img src={BookIcon} alt="" className="mt-0.5 h-4 w-4 shrink-0 sm:mt-0" />
            <p className="min-w-0 break-words">
              <span className="font-medium">Lessons:</span>{" "}
              {course.lessons || "—"}
            </p>
          </div> */}
          {/* <div className="flex items-start gap-2 text-sm font-normal leading-[18px] sm:items-center sm:gap-3 sm:leading-[19px]">
            <img
              src={ActivitiesIcon}
              alt=""
              className="mt-0.5 h-4 w-4 shrink-0 sm:mt-0"
            />
            <p className="min-w-0 break-words">
              <span className="font-medium">Activities:</span>{" "}
              {course.activities || "—"}
            </p>
          </div> */}
        </div>
      </div>

      <div className="mt-4 px-3 pb-4 sm:mt-5 sm:px-6 sm:pb-4">
        <Link
          to={`/courses/${course.id}`}
          className="flex w-full items-center justify-center rounded-xl border border-transparent bg-[#FF6636] py-3 text-sm font-bold leading-[19px] text-white transition-colors hover:border-[#FF6636] hover:bg-transparent hover:text-[#FF6636] sm:text-base xl:rounded-[18px] xl:py-[16.5px]"
        >
          Learn More
        </Link>
      </div>
    </div>
  );
};

export default CourseCard;
